//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { execQuery, contentAPIMixin } from '~/mixins/contentApi'
import gqlQuery from '~/gql/careers.gql.js'

export default {
  mixins: [contentAPIMixin],
  async asyncData (context) {
    return await execQuery(context, gqlQuery)
  },
  head () {
    return this.$head(this.meta)
  },
  computed: {
    subtitle () {
      const listings = this.jobListings || []
      if (listings.length === 0) return 'There are currently no open positions but please reach out to support@sungod.co with your CV if you think you\'ve got something to bring to the team!'
      if (listings.length === 1) return '1 open position'
      return `${listings.length} open positions`
    }
  }
}
